// Per-page SEO for the SPA: document title, description, canonical and OG tags.
// Restores site defaults on unmount. (No SSR — crawlers pick these up after render.)
import { useEffect } from "react";
import { BRAND } from "@/config/brand";

const DEFAULTS = {
  title: "Maziara — Conversations without judgement",
  description:
    "Maziara — a private adult conversation platform. Meet a real stranger or explore a fictional AI persona, without followers or public profiles. Adults 18+, India.",
};

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function useSeo({ title, absoluteTitle, description, path = "/", type = "website", noindex = false }) {
  useEffect(() => {
    const fullTitle = absoluteTitle || (title ? `${title} — ${BRAND.name}` : DEFAULTS.title);
    const desc = description || DEFAULTS.description;
    const url = `${BRAND.url}${path}`;

    document.title = fullTitle;
    upsertMeta("name", "description", desc);
    upsertMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:title", fullTitle);
    upsertMeta("property", "og:description", desc);
    upsertMeta("property", "og:url", url);
    upsertCanonical(url);

    return () => {
      document.title = DEFAULTS.title;
      upsertMeta("name", "description", DEFAULTS.description);
      upsertMeta("name", "robots", "index, follow");
      upsertMeta("property", "og:type", "website");
      upsertMeta("property", "og:title", DEFAULTS.title);
      upsertMeta("property", "og:description", DEFAULTS.description);
      upsertMeta("property", "og:url", BRAND.url);
      upsertCanonical(BRAND.url + "/");
    };
  }, [title, absoluteTitle, description, path, type, noindex]);
}
